// Queries
import materialTypes from "./MaterialTypesQuery.gql";
import quote from "./QuoteQuery.gql";
import quotes from "./QuotesQuery.gql";
import receiptLogSearch from "./ReceiptLogSearchQuery.gql";

// Mutations
import addQuote from "./AddQuoteMutation.gql";
import deleteQuote from "./DeleteQuoteMutation.gql";
import updateQuoteStatus from "./UpdateQuoteStatusMutation.gql";

export const Query = {
    quote,
    quotes,
    materialTypes,
    receiptLogSearch,
};

export const Mutation = {
    deleteQuote,
    addQuote,
    updateQuoteStatus,
};
